import { compose, find, prop, propEq, sortBy, toLower } from "ramda";
import type { IAppUser } from "types/user/app_user";

function findUserByEmail(
  email: string,
  users: IAppUser[]
): IAppUser | undefined {
  return find(propEq("email", email), users);
}

function findUserByUuid(uuid: string, users: IAppUser[]): IAppUser | undefined {
  return find(propEq("uuid", uuid), users);
}

// sort by Last, First, then email
const sortByFullnameAndEmail = sortBy(
  compose(
    toLower as (x: {}) => string, // todo: fix the ramda types to avoid this nonsense
    (user) =>
      `${prop("lastName", user)}-${prop("firstName", user)}-${prop(
        "email",
        user
      )}`
  )
);

function sortAlphabeticallyByFullnameAndEmail(users: IAppUser[]): IAppUser[] {
  return sortByFullnameAndEmail(users);
}

// todo: use generics instead of `any` without TypeScript yelling
function sortByName(things: any[]): any[] {
  return sortBy(
    compose(
      toLower as (x: {}) => string, // todo: fix the ramda types to avoid this nonsense
      prop("name")
    ),
    things
  );
}

export {
  findUserByEmail,
  findUserByUuid,
  sortAlphabeticallyByFullnameAndEmail,
  sortByName,
};
